var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('pages-core-app-bar'),_c('pages-core-view'),_c('pages-core-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }